import React from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Breadcrumbs } from '@/components/common/Breadcrumbs';
import { cn } from '@/lib/utils';
import { Outlet } from 'react-router-dom';

interface LayoutProps {
  children?: React.ReactNode;
  className?: string;
  showFooter?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  className,
  showFooter = true
}) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header onMenuToggle={toggleSidebar} />

      <div className="flex">
        {/* Sidebar */}
        {/* {showSidebar && (
          <Sidebar
            isOpen={sidebarOpen}
            onToggle={toggleSidebar}
          />
        )} */}

        {/* Main content */}
        <main className={cn(
          'flex-1 min-h-[calc(100vh-4rem)]',
          className
        )}>
          <div className="container mx-auto p-6">
            {/* Breadcrumbs */}
            <div className="mb-6">
              <Breadcrumbs />
            </div>

            {children ?? <Outlet />}
          </div>
        </main>
      </div>

      {/* Footer */}
      {showFooter && <Footer />}
    </div>
  );
};
